export default __webpack_public_path__ + "static/media/Hitchcut-Regular.4405dfbc.ttf";